module.exports = "<div ui-view></div>";


//////////////////
// WEBPACK FOOTER
// ./app/layout/layout.html
// module id = 207
// module chunks = 0